import React, { type ReactElement, type ReactNode } from 'react';

import styles from './PageContainer.module.scss';

type PageContainerProps = {
    children: ReactNode;
};

const PageContainer = ({ children }: PageContainerProps): ReactElement => {
    return <div className={styles.container}>{children}</div>;
};

export default PageContainer;
